import { ReportType } from "../models/ReportType";
import { agedReceivablesMapping } from "./agedReceivablesMapping";
import { incomeByCustomerMapping } from "./incomeByCustomerMapping";
import { salesTaxReportMapping } from "./salesTaxReportMapping";

export const getReportMapping = (report: ReportType) => {
  switch (report) {
    case ReportType.AgedReceivables:
      return agedReceivablesMapping;
    case ReportType.IncomeByCustomer:
      return incomeByCustomerMapping;
    case ReportType.SalesTaxReport:
    case ReportType.PaymentsTaxReport:
      return salesTaxReportMapping;
    default:
      return agedReceivablesMapping;
  }
};
